const BottomText = () => {
    return (
        <p className="text-xs text-sky-700 mx-4 my-20 bg-slate-100 p-4 border rounded border-slate-200" dir="ltr">
            Нужно открыть PDF в WORD, а затем скопировать таблицу в EXCEL. Его можно сохранить как CSV, который
            можно скопировать сюда.<br/><br/>

            Не нужно строить всю таблицу: нужно шореш и еще пару рамот. А ниже просто ставим троеточия.<br/><br/>

            label - (עמודה לסיווג) עמודה לחיזוי.<br/><br/>
            אפשר להסיר עמודות (תכונות) חד-חד-ערכיות כי אנחנו לא משתמשים בהם במהלך הסיווג.<br/><br/>
            עמודות מראה = עמודות עם ערכים הפוכים.<br/><br/>
            הגעתי לסיווג מושלם<br/><br/>
            קיבלנו סיווג מושלם<br/><br/>
            מכיוון ויתא לי עץ עם סיווג מושלם בעל 2 רמות וביקשו 3 רמות אזי אני מוסיפה רמה אחת נוספת<br/><br/>

            הושלם באמצעות הערך הערך הנפוץ ביותר בעמודה<br/><br/>


            בדקתי השלמה לפי ערך הנפוץ ביותר ולא הצלחתי לבנות מודל מסווג טוב
            (70%)
            ולכן השתמשתי בשיטת דמיון רשומות

            <br/><br/>

            Когда делаешь дискретизацию, надо сказать какой тип дискретизации ты делаешь - equal width or equal
            frequency
            <br/><br/>

            מספר רמות לא כולל את העלים
        </p>
    )
};

export default BottomText;